import { Signal, signal } from "@preact/signals-react";

export const marketOverview = signal({})

export const resetPricingMarketTable = () => {
    marketOverview.value = {}
}